















































































































import useFileUploads from "@/composables/useFileUploads";
import useTemplates from "@/composables/v3/useTemplates";
import useUpload from "@/composables/v3/useUpload";
import toastificationContent from "@/layouts/components/toastification/toastificationContent.vue";
import axios from "@/libs/axios";
// @ts-ignore
import i18n from "@/libs/i18n";
import { useChannelsStore } from "@/store/useChannelsStore";
import { useUploadAttachmentsStore } from "@/store/useUploadAttachmentsStore";
import { MediaTypeType } from "@/types/mediaType.type";
import { getFullPath } from "@/utils/assets";
import { resolveContentTypeIcon } from "@/utils/chats";
import { UploadDto } from "@saysimple-platform/dtos";
// @ts-ignore
import { required } from "@validations";
import { computed, defineComponent, onMounted, Ref, ref } from "@vue/composition-api";
import {
    BButton,
    BCard,
    BCardBody,
    BCardText,
    BCol,
    BEmbed,
    BForm,
    BFormCheckbox,
    BFormFile,
    BFormGroup,
    BFormInput,
    BLink,
    BRow,
    BSpinner,
    VBTooltip,
} from "bootstrap-vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { useToast } from "vue-toastification/composition";

export default defineComponent({
    computed: {
        MediaTypeType() {
            // @ts-ignore
            return MediaTypeType;
        },
    },
    emits: ["reset-template"],
    components: {
        ValidationProvider,
        ValidationObserver,
        required,
        BCardText,
        BFormInput,
        BFormGroup,
        BForm,
        BFormCheckbox,
        BFormFile,
        BRow,
        BCol,
        BButton,
        BCard,
        BCardBody,
        BSpinner,
        BEmbed,
        BLink,
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    setup(_, { emit }) {
        const { selectedTemplate } = useTemplates();
        const toast = useToast();
        const asset: Ref<UploadDto | null> = ref(null);
        const assetIsLocked = ref(Boolean(selectedTemplate.value.assetIsLocked));
        const { getAllowedFileTypes } = useFileUploads();

        onMounted(() => {
            if (selectedTemplate.value.assetId) {
                axios.get(`assets/${selectedTemplate.value.assetId}`).then((response) => (asset.value = response.data));
            }
        });

        const submit = async () => {
            // Save the asset if not already part of the template
            if (!selectedTemplate.value.assetId && asset.value) {
                await axios
                    .post(`assets`, asset.value)
                    .then((response) => (selectedTemplate.value.assetId = response.data.id));
            }

            axios
                .patch(`templates/${selectedTemplate.value.id}`, {
                    assetId: selectedTemplate.value.assetId,
                    assetIsLocked: assetIsLocked.value,
                })
                .then(() => {
                    toast({
                        component: toastificationContent,
                        props: {
                            title: i18n.t("entities.templates.approved-templates"),
                            text: i18n.t("toast.update.success", { entity: i18n.t("entities.templates.template") }),
                            icon: "check",
                            variant: "success",
                        },
                    });

                    emit!("reset-template");
                })
                .catch(() =>
                    toast({
                        component: toastificationContent,
                        props: {
                            title: i18n.t("entities.templates.approved-templates"),
                            text: i18n.t("toast.update.error", { entity: i18n.t("entities.templates.template") }),
                            icon: "times",
                            variant: "danger",
                        },
                    })
                );
        };

        const allowedFileTypes = computed(() =>
            getAllowedFileTypes(selectedTemplate.value.mediaType, { platform: "whatsapp" }).join(",")
        );

        const openFilePrompt = () => {
            document.getElementById("file").click();
        };

        const { clearAttachments } = useUploadAttachmentsStore();
        const { uploadSingle } = useUpload({ useStore: false });

        const isUploadingAsset = ref(false);
        const uploadAsset = (event: File) => {
            const channelsStore = useChannelsStore();
            if (!channelsStore.activeChatChannel) {
                return;
            }

            isUploadingAsset.value = true;
            clearAttachments();

            return uploadSingle(event, channelsStore.activeChatChannel)
                .then((data) => {
                    asset.value = data;
                })
                .catch((error) => {
                    toast({
                        component: toastificationContent,
                        props: {
                            title: i18n.t("upload.failed"),
                            text: i18n.t(error.message),
                            icon: "times",
                            variant: "danger",
                        },
                    });
                })
                .finally(() => {
                    isUploadingAsset.value = false;
                });
        };

        const removeAsset = () => {
            asset.value = null;
            selectedTemplate.value.assetId = null;
        };

        return {
            submit,
            selectedTemplate,
            allowedFileTypes,
            openFilePrompt,
            uploadAsset,
            isUploadingAsset,
            asset,
            removeAsset,
            getFullPath,
            resolveContentTypeIcon,
            assetIsLocked,
        };
    },
});
